module.exports = __webpack_public_path__ + "static/media/page3a.0060aabd.jpg";